import React from "react";
import ReactDOM from "react-dom";

import App from "./client/App";

ReactDOM.render(<App />, document.querySelector("#app"));
